import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { FC } from 'react';
import { Body2, Body2Bold, colors, spacing } from 'ui/theme';

const StyledList = styled.ul`
  list-style-type: disc;
  padding-left: ${spacing.threeQuarter};
  margin-bottom: 0;
`;

const ListContent = styled.div`
  display: inline;
  align-items: top;
  word-wrap: break-word;
  p {
    margin: ${spacing.quarter} 0;
    white-space: pre;
    color: ${colors.textWarning};
    text-wrap:auto;
    display: inline;
  }
`;

export const WhatsAppWarningBanner: FC<{ warnings: { title: string; description: string }[] }> = ({
  warnings,
}) => {
  return (
    <WarningBanner
      title="This template has issues that may impact sending."
      data-test="whatsapp-warning-banner"
    >
      <StyledList>
        {warnings.map(({ title, description }, i) => (
          <li key={`warning-li-${i}`}>
            <ListContent>
              <Body2Bold>{title}: </Body2Bold>
              <Body2>{description}</Body2>
            </ListContent>
          </li>
        ))}
      </StyledList>
    </WarningBanner>
  );
};
